import { render } from "./OptionPage.vue?vue&type=template&id=225610f3"
import script from "./OptionPage.vue?vue&type=script&lang=js"
export * from "./OptionPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__